import { render, staticRenderFns } from "./JImageList.vue?vue&type=template&id=04c335ed"
import script from "./JImageList.vue?vue&type=script&lang=js"
export * from "./JImageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports